/* eslint-disable */

export const protobufPackage = "od_protos.journey.data.categories";

export interface PlatformCategory {
  event?:
    | { $case: "accordionClickEvent"; accordionClickEvent: PlatformCategory_AccordionClickEvent }
    | { $case: "accordionViewEvent"; accordionViewEvent: PlatformCategory_AccordionViewEvent }
    | { $case: "boxViewEvent"; boxViewEvent: PlatformCategory_BoxViewEvent }
    | { $case: "buttonClickEvent"; buttonClickEvent: PlatformCategory_ButtonClickEvent }
    | { $case: "buttonViewEvent"; buttonViewEvent: PlatformCategory_ButtonViewEvent }
    | { $case: "cardViewEvent"; cardViewEvent: PlatformCategory_CardViewEvent }
    | { $case: "checkboxClickEvent"; checkboxClickEvent: PlatformCategory_CheckboxClickEvent }
    | { $case: "checkboxViewEvent"; checkboxViewEvent: PlatformCategory_CheckboxViewEvent }
    | { $case: "imageViewEvent"; imageViewEvent: PlatformCategory_ImageViewEvent }
    | { $case: "inputViewEvent"; inputViewEvent: PlatformCategory_InputViewEvent }
    | { $case: "linkClickEvent"; linkClickEvent: PlatformCategory_LinkClickEvent }
    | { $case: "linkViewEvent"; linkViewEvent: PlatformCategory_LinkViewEvent }
    | { $case: "radioClickEvent"; radioClickEvent: PlatformCategory_RadioClickEvent }
    | { $case: "radioViewEvent"; radioViewEvent: PlatformCategory_RadioViewEvent }
    | { $case: "textViewEvent"; textViewEvent: PlatformCategory_TextViewEvent }
    | { $case: "pageViewEvent"; pageViewEvent: PlatformCategory_PageViewEvent }
    | { $case: "pageLoadedEvent"; pageLoadedEvent: PlatformCategory_PageLoadedEvent }
    | { $case: "screenViewEvent"; screenViewEvent: PlatformCategory_ScreenViewEvent }
    | {
      $case: "customerOneTimeExperienceEvent";
      customerOneTimeExperienceEvent: PlatformCategory_CustomerOneTimeExperienceEvent;
    }
    | { $case: "leadOneTimeExperienceEvent"; leadOneTimeExperienceEvent: PlatformCategory_LeadOneTimeExperienceEvent }
    | { $case: "customerUnsubscribeEvent"; customerUnsubscribeEvent: PlatformCategory_CustomerUnsubscribeEvent }
    | { $case: "sessionStartEvent"; sessionStartEvent: PlatformCategory_SessionStartEvent }
    | { $case: "sessionEndEvent"; sessionEndEvent: PlatformCategory_SessionEndEvent }
    | { $case: "initialPageViewEvent"; initialPageViewEvent: PlatformCategory_InitialPageViewEvent }
    | { $case: "appLaunchedEvent"; appLaunchedEvent: PlatformCategory_AppLaunchedEvent }
    | { $case: "appForegroundedEvent"; appForegroundedEvent: PlatformCategory_AppForegroundedEvent }
    | { $case: "appBackgroundedEvent"; appBackgroundedEvent: PlatformCategory_AppBackgroundedEvent }
    | { $case: "appDownloadLinkEvent"; appDownloadLinkEvent: PlatformCategory_AppDownloadLinkEvent }
    | undefined;
}

export enum PlatformCategory_DevicePlatform {
  DEVICE_PLATFORM_UNSPECIFIED = 0,
  IOS = 1,
  ANDROID = 2,
  UNRECOGNIZED = -1,
}

export function platformCategory_DevicePlatformFromJSON(object: any): PlatformCategory_DevicePlatform {
  switch (object) {
    case 0:
    case "DEVICE_PLATFORM_UNSPECIFIED":
      return PlatformCategory_DevicePlatform.DEVICE_PLATFORM_UNSPECIFIED;
    case 1:
    case "IOS":
      return PlatformCategory_DevicePlatform.IOS;
    case 2:
    case "ANDROID":
      return PlatformCategory_DevicePlatform.ANDROID;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlatformCategory_DevicePlatform.UNRECOGNIZED;
  }
}

export function platformCategory_DevicePlatformToJSON(object: PlatformCategory_DevicePlatform): string {
  switch (object) {
    case PlatformCategory_DevicePlatform.DEVICE_PLATFORM_UNSPECIFIED:
      return "DEVICE_PLATFORM_UNSPECIFIED";
    case PlatformCategory_DevicePlatform.IOS:
      return "IOS";
    case PlatformCategory_DevicePlatform.ANDROID:
      return "ANDROID";
    case PlatformCategory_DevicePlatform.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PlatformCategory_LinkMethod {
  LINK_METHOD_UNSPECIFIED = 0,
  QR_SCAN = 1,
  CLICK = 2,
  UNRECOGNIZED = -1,
}

export function platformCategory_LinkMethodFromJSON(object: any): PlatformCategory_LinkMethod {
  switch (object) {
    case 0:
    case "LINK_METHOD_UNSPECIFIED":
      return PlatformCategory_LinkMethod.LINK_METHOD_UNSPECIFIED;
    case 1:
    case "QR_SCAN":
      return PlatformCategory_LinkMethod.QR_SCAN;
    case 2:
    case "CLICK":
      return PlatformCategory_LinkMethod.CLICK;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlatformCategory_LinkMethod.UNRECOGNIZED;
  }
}

export function platformCategory_LinkMethodToJSON(object: PlatformCategory_LinkMethod): string {
  switch (object) {
    case PlatformCategory_LinkMethod.LINK_METHOD_UNSPECIFIED:
      return "LINK_METHOD_UNSPECIFIED";
    case PlatformCategory_LinkMethod.QR_SCAN:
      return "QR_SCAN";
    case PlatformCategory_LinkMethod.CLICK:
      return "CLICK";
    case PlatformCategory_LinkMethod.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PlatformCategory_AppDownloadLinkEvent {
  devicePlatform: PlatformCategory_DevicePlatform;
  linkMethod: PlatformCategory_LinkMethod;
}

export interface PlatformCategory_AccordionClickEvent {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual accordion in the accordion list */
  accordionName: string;
}

export interface PlatformCategory_AccordionViewEvent {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_BoxViewEvent {
  /**
   * Canonical identifier of the box
   * Convention: {app_name}-{box_name}
   * box_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_ButtonClickEvent {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_ButtonViewEvent {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_CardViewEvent {
  /**
   * Canonical identifier of the card
   * Convention: {app_name}-{card_name}
   * card_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_CheckboxClickEvent {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual checkbox in the checkbox group */
  optionName: string;
}

export interface PlatformCategory_CheckboxViewEvent {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_ImageViewEvent {
  /**
   * Canonical identifier of the image
   * Convention: {app_name}-{image_name}
   * image_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_InputViewEvent {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_LinkClickEvent {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_LinkViewEvent {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_RadioClickEvent {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual radio in the radio group */
  optionName: string;
}

export interface PlatformCategory_RadioViewEvent {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName: string;
}

export interface PlatformCategory_TextViewEvent {
  /**
   * Canonical identifier of the text
   * Convention: {app_name}-{text_name}
   * text_name should be unique within the app
   */
  targetName: string;
}

/**
 * website_source field contains the page's url, etc.
 * No other event-specific data needed for now.
 */
export interface PlatformCategory_PageViewEvent {
}

/** Used for measuring page performance, e.g. load time. */
export interface PlatformCategory_PageLoadedEvent {
  loadTimeMs?: number | undefined;
  routerPath?: string | undefined;
}

/**
 * mobile_source field contains the screen's focusRouteName, etc.
 * No other event-specfic data needed for now.
 */
export interface PlatformCategory_ScreenViewEvent {
}

export interface PlatformCategory_CustomerOneTimeExperienceEvent {
  experienceName: string;
}

export interface PlatformCategory_LeadOneTimeExperienceEvent {
  experienceName: string;
  /** @deprecated */
  leadId: string;
  sellerLeadUuid: string;
}

export interface PlatformCategory_CustomerUnsubscribeEvent {
  feedName: string;
}

export interface PlatformCategory_SessionStartEvent {
}

export interface PlatformCategory_SessionEndEvent {
}

/** temporary initial page_view event */
export interface PlatformCategory_InitialPageViewEvent {
}

/** App lifecycle events for mobile apps */
export interface PlatformCategory_AppLaunchedEvent {
  /** Whether app transitioned from background to foreground (vs cold start) */
  fromBackground: boolean;
  /** Deep link URL if app was launched via URL */
  url?:
    | string
    | undefined;
  /** Bundle ID of referring application if launched from another app */
  referringApplication?:
    | string
    | undefined;
  /** App version (e.g., "1.2.3") */
  version: string;
  /** App build number (e.g., "456") */
  build: string;
}

export interface PlatformCategory_AppForegroundedEvent {
  /** Whether app transitioned from background (always true for this event) */
  fromBackground: boolean;
  /** App version (e.g., "1.2.3") */
  version: string;
  /** App build number (e.g., "456") */
  build: string;
}

export interface PlatformCategory_AppBackgroundedEvent {
  /** App version (e.g., "1.2.3") */
  version: string;
  /** App build number (e.g., "456") */
  build: string;
}

function createBasePlatformCategory(): PlatformCategory {
  return { event: undefined };
}

export const PlatformCategory = {
  fromJSON(object: any): PlatformCategory {
    return {
      event: isSet(object.accordionClickEvent)
        ? {
          $case: "accordionClickEvent",
          accordionClickEvent: PlatformCategory_AccordionClickEvent.fromJSON(object.accordionClickEvent),
        }
        : isSet(object.accordionViewEvent)
        ? {
          $case: "accordionViewEvent",
          accordionViewEvent: PlatformCategory_AccordionViewEvent.fromJSON(object.accordionViewEvent),
        }
        : isSet(object.boxViewEvent)
        ? { $case: "boxViewEvent", boxViewEvent: PlatformCategory_BoxViewEvent.fromJSON(object.boxViewEvent) }
        : isSet(object.buttonClickEvent)
        ? {
          $case: "buttonClickEvent",
          buttonClickEvent: PlatformCategory_ButtonClickEvent.fromJSON(object.buttonClickEvent),
        }
        : isSet(object.buttonViewEvent)
        ? {
          $case: "buttonViewEvent",
          buttonViewEvent: PlatformCategory_ButtonViewEvent.fromJSON(object.buttonViewEvent),
        }
        : isSet(object.cardViewEvent)
        ? { $case: "cardViewEvent", cardViewEvent: PlatformCategory_CardViewEvent.fromJSON(object.cardViewEvent) }
        : isSet(object.checkboxClickEvent)
        ? {
          $case: "checkboxClickEvent",
          checkboxClickEvent: PlatformCategory_CheckboxClickEvent.fromJSON(object.checkboxClickEvent),
        }
        : isSet(object.checkboxViewEvent)
        ? {
          $case: "checkboxViewEvent",
          checkboxViewEvent: PlatformCategory_CheckboxViewEvent.fromJSON(object.checkboxViewEvent),
        }
        : isSet(object.imageViewEvent)
        ? { $case: "imageViewEvent", imageViewEvent: PlatformCategory_ImageViewEvent.fromJSON(object.imageViewEvent) }
        : isSet(object.inputViewEvent)
        ? { $case: "inputViewEvent", inputViewEvent: PlatformCategory_InputViewEvent.fromJSON(object.inputViewEvent) }
        : isSet(object.linkClickEvent)
        ? { $case: "linkClickEvent", linkClickEvent: PlatformCategory_LinkClickEvent.fromJSON(object.linkClickEvent) }
        : isSet(object.linkViewEvent)
        ? { $case: "linkViewEvent", linkViewEvent: PlatformCategory_LinkViewEvent.fromJSON(object.linkViewEvent) }
        : isSet(object.radioClickEvent)
        ? {
          $case: "radioClickEvent",
          radioClickEvent: PlatformCategory_RadioClickEvent.fromJSON(object.radioClickEvent),
        }
        : isSet(object.radioViewEvent)
        ? { $case: "radioViewEvent", radioViewEvent: PlatformCategory_RadioViewEvent.fromJSON(object.radioViewEvent) }
        : isSet(object.textViewEvent)
        ? { $case: "textViewEvent", textViewEvent: PlatformCategory_TextViewEvent.fromJSON(object.textViewEvent) }
        : isSet(object.pageViewEvent)
        ? { $case: "pageViewEvent", pageViewEvent: PlatformCategory_PageViewEvent.fromJSON(object.pageViewEvent) }
        : isSet(object.pageLoadedEvent)
        ? {
          $case: "pageLoadedEvent",
          pageLoadedEvent: PlatformCategory_PageLoadedEvent.fromJSON(object.pageLoadedEvent),
        }
        : isSet(object.screenViewEvent)
        ? {
          $case: "screenViewEvent",
          screenViewEvent: PlatformCategory_ScreenViewEvent.fromJSON(object.screenViewEvent),
        }
        : isSet(object.customerOneTimeExperienceEvent)
        ? {
          $case: "customerOneTimeExperienceEvent",
          customerOneTimeExperienceEvent: PlatformCategory_CustomerOneTimeExperienceEvent.fromJSON(
            object.customerOneTimeExperienceEvent,
          ),
        }
        : isSet(object.leadOneTimeExperienceEvent)
        ? {
          $case: "leadOneTimeExperienceEvent",
          leadOneTimeExperienceEvent: PlatformCategory_LeadOneTimeExperienceEvent.fromJSON(
            object.leadOneTimeExperienceEvent,
          ),
        }
        : isSet(object.customerUnsubscribeEvent)
        ? {
          $case: "customerUnsubscribeEvent",
          customerUnsubscribeEvent: PlatformCategory_CustomerUnsubscribeEvent.fromJSON(object.customerUnsubscribeEvent),
        }
        : isSet(object.sessionStartEvent)
        ? {
          $case: "sessionStartEvent",
          sessionStartEvent: PlatformCategory_SessionStartEvent.fromJSON(object.sessionStartEvent),
        }
        : isSet(object.sessionEndEvent)
        ? {
          $case: "sessionEndEvent",
          sessionEndEvent: PlatformCategory_SessionEndEvent.fromJSON(object.sessionEndEvent),
        }
        : isSet(object.initialPageViewEvent)
        ? {
          $case: "initialPageViewEvent",
          initialPageViewEvent: PlatformCategory_InitialPageViewEvent.fromJSON(object.initialPageViewEvent),
        }
        : isSet(object.appLaunchedEvent)
        ? {
          $case: "appLaunchedEvent",
          appLaunchedEvent: PlatformCategory_AppLaunchedEvent.fromJSON(object.appLaunchedEvent),
        }
        : isSet(object.appForegroundedEvent)
        ? {
          $case: "appForegroundedEvent",
          appForegroundedEvent: PlatformCategory_AppForegroundedEvent.fromJSON(object.appForegroundedEvent),
        }
        : isSet(object.appBackgroundedEvent)
        ? {
          $case: "appBackgroundedEvent",
          appBackgroundedEvent: PlatformCategory_AppBackgroundedEvent.fromJSON(object.appBackgroundedEvent),
        }
        : isSet(object.appDownloadLinkEvent)
        ? {
          $case: "appDownloadLinkEvent",
          appDownloadLinkEvent: PlatformCategory_AppDownloadLinkEvent.fromJSON(object.appDownloadLinkEvent),
        }
        : undefined,
    };
  },

  toJSON(message: PlatformCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "accordionClickEvent") {
      obj.accordionClickEvent = PlatformCategory_AccordionClickEvent.toJSON(message.event.accordionClickEvent);
    }
    if (message.event?.$case === "accordionViewEvent") {
      obj.accordionViewEvent = PlatformCategory_AccordionViewEvent.toJSON(message.event.accordionViewEvent);
    }
    if (message.event?.$case === "boxViewEvent") {
      obj.boxViewEvent = PlatformCategory_BoxViewEvent.toJSON(message.event.boxViewEvent);
    }
    if (message.event?.$case === "buttonClickEvent") {
      obj.buttonClickEvent = PlatformCategory_ButtonClickEvent.toJSON(message.event.buttonClickEvent);
    }
    if (message.event?.$case === "buttonViewEvent") {
      obj.buttonViewEvent = PlatformCategory_ButtonViewEvent.toJSON(message.event.buttonViewEvent);
    }
    if (message.event?.$case === "cardViewEvent") {
      obj.cardViewEvent = PlatformCategory_CardViewEvent.toJSON(message.event.cardViewEvent);
    }
    if (message.event?.$case === "checkboxClickEvent") {
      obj.checkboxClickEvent = PlatformCategory_CheckboxClickEvent.toJSON(message.event.checkboxClickEvent);
    }
    if (message.event?.$case === "checkboxViewEvent") {
      obj.checkboxViewEvent = PlatformCategory_CheckboxViewEvent.toJSON(message.event.checkboxViewEvent);
    }
    if (message.event?.$case === "imageViewEvent") {
      obj.imageViewEvent = PlatformCategory_ImageViewEvent.toJSON(message.event.imageViewEvent);
    }
    if (message.event?.$case === "inputViewEvent") {
      obj.inputViewEvent = PlatformCategory_InputViewEvent.toJSON(message.event.inputViewEvent);
    }
    if (message.event?.$case === "linkClickEvent") {
      obj.linkClickEvent = PlatformCategory_LinkClickEvent.toJSON(message.event.linkClickEvent);
    }
    if (message.event?.$case === "linkViewEvent") {
      obj.linkViewEvent = PlatformCategory_LinkViewEvent.toJSON(message.event.linkViewEvent);
    }
    if (message.event?.$case === "radioClickEvent") {
      obj.radioClickEvent = PlatformCategory_RadioClickEvent.toJSON(message.event.radioClickEvent);
    }
    if (message.event?.$case === "radioViewEvent") {
      obj.radioViewEvent = PlatformCategory_RadioViewEvent.toJSON(message.event.radioViewEvent);
    }
    if (message.event?.$case === "textViewEvent") {
      obj.textViewEvent = PlatformCategory_TextViewEvent.toJSON(message.event.textViewEvent);
    }
    if (message.event?.$case === "pageViewEvent") {
      obj.pageViewEvent = PlatformCategory_PageViewEvent.toJSON(message.event.pageViewEvent);
    }
    if (message.event?.$case === "pageLoadedEvent") {
      obj.pageLoadedEvent = PlatformCategory_PageLoadedEvent.toJSON(message.event.pageLoadedEvent);
    }
    if (message.event?.$case === "screenViewEvent") {
      obj.screenViewEvent = PlatformCategory_ScreenViewEvent.toJSON(message.event.screenViewEvent);
    }
    if (message.event?.$case === "customerOneTimeExperienceEvent") {
      obj.customerOneTimeExperienceEvent = PlatformCategory_CustomerOneTimeExperienceEvent.toJSON(
        message.event.customerOneTimeExperienceEvent,
      );
    }
    if (message.event?.$case === "leadOneTimeExperienceEvent") {
      obj.leadOneTimeExperienceEvent = PlatformCategory_LeadOneTimeExperienceEvent.toJSON(
        message.event.leadOneTimeExperienceEvent,
      );
    }
    if (message.event?.$case === "customerUnsubscribeEvent") {
      obj.customerUnsubscribeEvent = PlatformCategory_CustomerUnsubscribeEvent.toJSON(
        message.event.customerUnsubscribeEvent,
      );
    }
    if (message.event?.$case === "sessionStartEvent") {
      obj.sessionStartEvent = PlatformCategory_SessionStartEvent.toJSON(message.event.sessionStartEvent);
    }
    if (message.event?.$case === "sessionEndEvent") {
      obj.sessionEndEvent = PlatformCategory_SessionEndEvent.toJSON(message.event.sessionEndEvent);
    }
    if (message.event?.$case === "initialPageViewEvent") {
      obj.initialPageViewEvent = PlatformCategory_InitialPageViewEvent.toJSON(message.event.initialPageViewEvent);
    }
    if (message.event?.$case === "appLaunchedEvent") {
      obj.appLaunchedEvent = PlatformCategory_AppLaunchedEvent.toJSON(message.event.appLaunchedEvent);
    }
    if (message.event?.$case === "appForegroundedEvent") {
      obj.appForegroundedEvent = PlatformCategory_AppForegroundedEvent.toJSON(message.event.appForegroundedEvent);
    }
    if (message.event?.$case === "appBackgroundedEvent") {
      obj.appBackgroundedEvent = PlatformCategory_AppBackgroundedEvent.toJSON(message.event.appBackgroundedEvent);
    }
    if (message.event?.$case === "appDownloadLinkEvent") {
      obj.appDownloadLinkEvent = PlatformCategory_AppDownloadLinkEvent.toJSON(message.event.appDownloadLinkEvent);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory>, I>>(base?: I): PlatformCategory {
    return PlatformCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory>, I>>(object: I): PlatformCategory {
    const message = createBasePlatformCategory();
    if (
      object.event?.$case === "accordionClickEvent" &&
      object.event?.accordionClickEvent !== undefined &&
      object.event?.accordionClickEvent !== null
    ) {
      message.event = {
        $case: "accordionClickEvent",
        accordionClickEvent: PlatformCategory_AccordionClickEvent.fromPartial(object.event.accordionClickEvent),
      };
    }
    if (
      object.event?.$case === "accordionViewEvent" &&
      object.event?.accordionViewEvent !== undefined &&
      object.event?.accordionViewEvent !== null
    ) {
      message.event = {
        $case: "accordionViewEvent",
        accordionViewEvent: PlatformCategory_AccordionViewEvent.fromPartial(object.event.accordionViewEvent),
      };
    }
    if (
      object.event?.$case === "boxViewEvent" &&
      object.event?.boxViewEvent !== undefined &&
      object.event?.boxViewEvent !== null
    ) {
      message.event = {
        $case: "boxViewEvent",
        boxViewEvent: PlatformCategory_BoxViewEvent.fromPartial(object.event.boxViewEvent),
      };
    }
    if (
      object.event?.$case === "buttonClickEvent" &&
      object.event?.buttonClickEvent !== undefined &&
      object.event?.buttonClickEvent !== null
    ) {
      message.event = {
        $case: "buttonClickEvent",
        buttonClickEvent: PlatformCategory_ButtonClickEvent.fromPartial(object.event.buttonClickEvent),
      };
    }
    if (
      object.event?.$case === "buttonViewEvent" &&
      object.event?.buttonViewEvent !== undefined &&
      object.event?.buttonViewEvent !== null
    ) {
      message.event = {
        $case: "buttonViewEvent",
        buttonViewEvent: PlatformCategory_ButtonViewEvent.fromPartial(object.event.buttonViewEvent),
      };
    }
    if (
      object.event?.$case === "cardViewEvent" &&
      object.event?.cardViewEvent !== undefined &&
      object.event?.cardViewEvent !== null
    ) {
      message.event = {
        $case: "cardViewEvent",
        cardViewEvent: PlatformCategory_CardViewEvent.fromPartial(object.event.cardViewEvent),
      };
    }
    if (
      object.event?.$case === "checkboxClickEvent" &&
      object.event?.checkboxClickEvent !== undefined &&
      object.event?.checkboxClickEvent !== null
    ) {
      message.event = {
        $case: "checkboxClickEvent",
        checkboxClickEvent: PlatformCategory_CheckboxClickEvent.fromPartial(object.event.checkboxClickEvent),
      };
    }
    if (
      object.event?.$case === "checkboxViewEvent" &&
      object.event?.checkboxViewEvent !== undefined &&
      object.event?.checkboxViewEvent !== null
    ) {
      message.event = {
        $case: "checkboxViewEvent",
        checkboxViewEvent: PlatformCategory_CheckboxViewEvent.fromPartial(object.event.checkboxViewEvent),
      };
    }
    if (
      object.event?.$case === "imageViewEvent" &&
      object.event?.imageViewEvent !== undefined &&
      object.event?.imageViewEvent !== null
    ) {
      message.event = {
        $case: "imageViewEvent",
        imageViewEvent: PlatformCategory_ImageViewEvent.fromPartial(object.event.imageViewEvent),
      };
    }
    if (
      object.event?.$case === "inputViewEvent" &&
      object.event?.inputViewEvent !== undefined &&
      object.event?.inputViewEvent !== null
    ) {
      message.event = {
        $case: "inputViewEvent",
        inputViewEvent: PlatformCategory_InputViewEvent.fromPartial(object.event.inputViewEvent),
      };
    }
    if (
      object.event?.$case === "linkClickEvent" &&
      object.event?.linkClickEvent !== undefined &&
      object.event?.linkClickEvent !== null
    ) {
      message.event = {
        $case: "linkClickEvent",
        linkClickEvent: PlatformCategory_LinkClickEvent.fromPartial(object.event.linkClickEvent),
      };
    }
    if (
      object.event?.$case === "linkViewEvent" &&
      object.event?.linkViewEvent !== undefined &&
      object.event?.linkViewEvent !== null
    ) {
      message.event = {
        $case: "linkViewEvent",
        linkViewEvent: PlatformCategory_LinkViewEvent.fromPartial(object.event.linkViewEvent),
      };
    }
    if (
      object.event?.$case === "radioClickEvent" &&
      object.event?.radioClickEvent !== undefined &&
      object.event?.radioClickEvent !== null
    ) {
      message.event = {
        $case: "radioClickEvent",
        radioClickEvent: PlatformCategory_RadioClickEvent.fromPartial(object.event.radioClickEvent),
      };
    }
    if (
      object.event?.$case === "radioViewEvent" &&
      object.event?.radioViewEvent !== undefined &&
      object.event?.radioViewEvent !== null
    ) {
      message.event = {
        $case: "radioViewEvent",
        radioViewEvent: PlatformCategory_RadioViewEvent.fromPartial(object.event.radioViewEvent),
      };
    }
    if (
      object.event?.$case === "textViewEvent" &&
      object.event?.textViewEvent !== undefined &&
      object.event?.textViewEvent !== null
    ) {
      message.event = {
        $case: "textViewEvent",
        textViewEvent: PlatformCategory_TextViewEvent.fromPartial(object.event.textViewEvent),
      };
    }
    if (
      object.event?.$case === "pageViewEvent" &&
      object.event?.pageViewEvent !== undefined &&
      object.event?.pageViewEvent !== null
    ) {
      message.event = {
        $case: "pageViewEvent",
        pageViewEvent: PlatformCategory_PageViewEvent.fromPartial(object.event.pageViewEvent),
      };
    }
    if (
      object.event?.$case === "pageLoadedEvent" &&
      object.event?.pageLoadedEvent !== undefined &&
      object.event?.pageLoadedEvent !== null
    ) {
      message.event = {
        $case: "pageLoadedEvent",
        pageLoadedEvent: PlatformCategory_PageLoadedEvent.fromPartial(object.event.pageLoadedEvent),
      };
    }
    if (
      object.event?.$case === "screenViewEvent" &&
      object.event?.screenViewEvent !== undefined &&
      object.event?.screenViewEvent !== null
    ) {
      message.event = {
        $case: "screenViewEvent",
        screenViewEvent: PlatformCategory_ScreenViewEvent.fromPartial(object.event.screenViewEvent),
      };
    }
    if (
      object.event?.$case === "customerOneTimeExperienceEvent" &&
      object.event?.customerOneTimeExperienceEvent !== undefined &&
      object.event?.customerOneTimeExperienceEvent !== null
    ) {
      message.event = {
        $case: "customerOneTimeExperienceEvent",
        customerOneTimeExperienceEvent: PlatformCategory_CustomerOneTimeExperienceEvent.fromPartial(
          object.event.customerOneTimeExperienceEvent,
        ),
      };
    }
    if (
      object.event?.$case === "leadOneTimeExperienceEvent" &&
      object.event?.leadOneTimeExperienceEvent !== undefined &&
      object.event?.leadOneTimeExperienceEvent !== null
    ) {
      message.event = {
        $case: "leadOneTimeExperienceEvent",
        leadOneTimeExperienceEvent: PlatformCategory_LeadOneTimeExperienceEvent.fromPartial(
          object.event.leadOneTimeExperienceEvent,
        ),
      };
    }
    if (
      object.event?.$case === "customerUnsubscribeEvent" &&
      object.event?.customerUnsubscribeEvent !== undefined &&
      object.event?.customerUnsubscribeEvent !== null
    ) {
      message.event = {
        $case: "customerUnsubscribeEvent",
        customerUnsubscribeEvent: PlatformCategory_CustomerUnsubscribeEvent.fromPartial(
          object.event.customerUnsubscribeEvent,
        ),
      };
    }
    if (
      object.event?.$case === "sessionStartEvent" &&
      object.event?.sessionStartEvent !== undefined &&
      object.event?.sessionStartEvent !== null
    ) {
      message.event = {
        $case: "sessionStartEvent",
        sessionStartEvent: PlatformCategory_SessionStartEvent.fromPartial(object.event.sessionStartEvent),
      };
    }
    if (
      object.event?.$case === "sessionEndEvent" &&
      object.event?.sessionEndEvent !== undefined &&
      object.event?.sessionEndEvent !== null
    ) {
      message.event = {
        $case: "sessionEndEvent",
        sessionEndEvent: PlatformCategory_SessionEndEvent.fromPartial(object.event.sessionEndEvent),
      };
    }
    if (
      object.event?.$case === "initialPageViewEvent" &&
      object.event?.initialPageViewEvent !== undefined &&
      object.event?.initialPageViewEvent !== null
    ) {
      message.event = {
        $case: "initialPageViewEvent",
        initialPageViewEvent: PlatformCategory_InitialPageViewEvent.fromPartial(object.event.initialPageViewEvent),
      };
    }
    if (
      object.event?.$case === "appLaunchedEvent" &&
      object.event?.appLaunchedEvent !== undefined &&
      object.event?.appLaunchedEvent !== null
    ) {
      message.event = {
        $case: "appLaunchedEvent",
        appLaunchedEvent: PlatformCategory_AppLaunchedEvent.fromPartial(object.event.appLaunchedEvent),
      };
    }
    if (
      object.event?.$case === "appForegroundedEvent" &&
      object.event?.appForegroundedEvent !== undefined &&
      object.event?.appForegroundedEvent !== null
    ) {
      message.event = {
        $case: "appForegroundedEvent",
        appForegroundedEvent: PlatformCategory_AppForegroundedEvent.fromPartial(object.event.appForegroundedEvent),
      };
    }
    if (
      object.event?.$case === "appBackgroundedEvent" &&
      object.event?.appBackgroundedEvent !== undefined &&
      object.event?.appBackgroundedEvent !== null
    ) {
      message.event = {
        $case: "appBackgroundedEvent",
        appBackgroundedEvent: PlatformCategory_AppBackgroundedEvent.fromPartial(object.event.appBackgroundedEvent),
      };
    }
    if (
      object.event?.$case === "appDownloadLinkEvent" &&
      object.event?.appDownloadLinkEvent !== undefined &&
      object.event?.appDownloadLinkEvent !== null
    ) {
      message.event = {
        $case: "appDownloadLinkEvent",
        appDownloadLinkEvent: PlatformCategory_AppDownloadLinkEvent.fromPartial(object.event.appDownloadLinkEvent),
      };
    }
    return message;
  },
};

function createBasePlatformCategory_AppDownloadLinkEvent(): PlatformCategory_AppDownloadLinkEvent {
  return { devicePlatform: 0, linkMethod: 0 };
}

export const PlatformCategory_AppDownloadLinkEvent = {
  fromJSON(object: any): PlatformCategory_AppDownloadLinkEvent {
    return {
      devicePlatform: isSet(object.devicePlatform) ? platformCategory_DevicePlatformFromJSON(object.devicePlatform) : 0,
      linkMethod: isSet(object.linkMethod) ? platformCategory_LinkMethodFromJSON(object.linkMethod) : 0,
    };
  },

  toJSON(message: PlatformCategory_AppDownloadLinkEvent): unknown {
    const obj: any = {};
    if (message.devicePlatform !== 0) {
      obj.devicePlatform = platformCategory_DevicePlatformToJSON(message.devicePlatform);
    }
    if (message.linkMethod !== 0) {
      obj.linkMethod = platformCategory_LinkMethodToJSON(message.linkMethod);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AppDownloadLinkEvent>, I>>(
    base?: I,
  ): PlatformCategory_AppDownloadLinkEvent {
    return PlatformCategory_AppDownloadLinkEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AppDownloadLinkEvent>, I>>(
    object: I,
  ): PlatformCategory_AppDownloadLinkEvent {
    const message = createBasePlatformCategory_AppDownloadLinkEvent();
    message.devicePlatform = object.devicePlatform ?? 0;
    message.linkMethod = object.linkMethod ?? 0;
    return message;
  },
};

function createBasePlatformCategory_AccordionClickEvent(): PlatformCategory_AccordionClickEvent {
  return { targetName: "", accordionName: "" };
}

export const PlatformCategory_AccordionClickEvent = {
  fromJSON(object: any): PlatformCategory_AccordionClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : "",
      accordionName: isSet(object.accordionName) ? String(object.accordionName) : "",
    };
  },

  toJSON(message: PlatformCategory_AccordionClickEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    if (message.accordionName !== "") {
      obj.accordionName = message.accordionName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AccordionClickEvent>, I>>(
    base?: I,
  ): PlatformCategory_AccordionClickEvent {
    return PlatformCategory_AccordionClickEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AccordionClickEvent>, I>>(
    object: I,
  ): PlatformCategory_AccordionClickEvent {
    const message = createBasePlatformCategory_AccordionClickEvent();
    message.targetName = object.targetName ?? "";
    message.accordionName = object.accordionName ?? "";
    return message;
  },
};

function createBasePlatformCategory_AccordionViewEvent(): PlatformCategory_AccordionViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_AccordionViewEvent = {
  fromJSON(object: any): PlatformCategory_AccordionViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_AccordionViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AccordionViewEvent>, I>>(
    base?: I,
  ): PlatformCategory_AccordionViewEvent {
    return PlatformCategory_AccordionViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AccordionViewEvent>, I>>(
    object: I,
  ): PlatformCategory_AccordionViewEvent {
    const message = createBasePlatformCategory_AccordionViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_BoxViewEvent(): PlatformCategory_BoxViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_BoxViewEvent = {
  fromJSON(object: any): PlatformCategory_BoxViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_BoxViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_BoxViewEvent>, I>>(base?: I): PlatformCategory_BoxViewEvent {
    return PlatformCategory_BoxViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_BoxViewEvent>, I>>(
    object: I,
  ): PlatformCategory_BoxViewEvent {
    const message = createBasePlatformCategory_BoxViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_ButtonClickEvent(): PlatformCategory_ButtonClickEvent {
  return { targetName: "" };
}

export const PlatformCategory_ButtonClickEvent = {
  fromJSON(object: any): PlatformCategory_ButtonClickEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_ButtonClickEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_ButtonClickEvent>, I>>(
    base?: I,
  ): PlatformCategory_ButtonClickEvent {
    return PlatformCategory_ButtonClickEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_ButtonClickEvent>, I>>(
    object: I,
  ): PlatformCategory_ButtonClickEvent {
    const message = createBasePlatformCategory_ButtonClickEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_ButtonViewEvent(): PlatformCategory_ButtonViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_ButtonViewEvent = {
  fromJSON(object: any): PlatformCategory_ButtonViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_ButtonViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_ButtonViewEvent>, I>>(
    base?: I,
  ): PlatformCategory_ButtonViewEvent {
    return PlatformCategory_ButtonViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_ButtonViewEvent>, I>>(
    object: I,
  ): PlatformCategory_ButtonViewEvent {
    const message = createBasePlatformCategory_ButtonViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_CardViewEvent(): PlatformCategory_CardViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_CardViewEvent = {
  fromJSON(object: any): PlatformCategory_CardViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_CardViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_CardViewEvent>, I>>(base?: I): PlatformCategory_CardViewEvent {
    return PlatformCategory_CardViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_CardViewEvent>, I>>(
    object: I,
  ): PlatformCategory_CardViewEvent {
    const message = createBasePlatformCategory_CardViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_CheckboxClickEvent(): PlatformCategory_CheckboxClickEvent {
  return { targetName: "", optionName: "" };
}

export const PlatformCategory_CheckboxClickEvent = {
  fromJSON(object: any): PlatformCategory_CheckboxClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : "",
      optionName: isSet(object.optionName) ? String(object.optionName) : "",
    };
  },

  toJSON(message: PlatformCategory_CheckboxClickEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    if (message.optionName !== "") {
      obj.optionName = message.optionName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_CheckboxClickEvent>, I>>(
    base?: I,
  ): PlatformCategory_CheckboxClickEvent {
    return PlatformCategory_CheckboxClickEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_CheckboxClickEvent>, I>>(
    object: I,
  ): PlatformCategory_CheckboxClickEvent {
    const message = createBasePlatformCategory_CheckboxClickEvent();
    message.targetName = object.targetName ?? "";
    message.optionName = object.optionName ?? "";
    return message;
  },
};

function createBasePlatformCategory_CheckboxViewEvent(): PlatformCategory_CheckboxViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_CheckboxViewEvent = {
  fromJSON(object: any): PlatformCategory_CheckboxViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_CheckboxViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_CheckboxViewEvent>, I>>(
    base?: I,
  ): PlatformCategory_CheckboxViewEvent {
    return PlatformCategory_CheckboxViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_CheckboxViewEvent>, I>>(
    object: I,
  ): PlatformCategory_CheckboxViewEvent {
    const message = createBasePlatformCategory_CheckboxViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_ImageViewEvent(): PlatformCategory_ImageViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_ImageViewEvent = {
  fromJSON(object: any): PlatformCategory_ImageViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_ImageViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_ImageViewEvent>, I>>(base?: I): PlatformCategory_ImageViewEvent {
    return PlatformCategory_ImageViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_ImageViewEvent>, I>>(
    object: I,
  ): PlatformCategory_ImageViewEvent {
    const message = createBasePlatformCategory_ImageViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_InputViewEvent(): PlatformCategory_InputViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_InputViewEvent = {
  fromJSON(object: any): PlatformCategory_InputViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_InputViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_InputViewEvent>, I>>(base?: I): PlatformCategory_InputViewEvent {
    return PlatformCategory_InputViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_InputViewEvent>, I>>(
    object: I,
  ): PlatformCategory_InputViewEvent {
    const message = createBasePlatformCategory_InputViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_LinkClickEvent(): PlatformCategory_LinkClickEvent {
  return { targetName: "" };
}

export const PlatformCategory_LinkClickEvent = {
  fromJSON(object: any): PlatformCategory_LinkClickEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_LinkClickEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_LinkClickEvent>, I>>(base?: I): PlatformCategory_LinkClickEvent {
    return PlatformCategory_LinkClickEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_LinkClickEvent>, I>>(
    object: I,
  ): PlatformCategory_LinkClickEvent {
    const message = createBasePlatformCategory_LinkClickEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_LinkViewEvent(): PlatformCategory_LinkViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_LinkViewEvent = {
  fromJSON(object: any): PlatformCategory_LinkViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_LinkViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_LinkViewEvent>, I>>(base?: I): PlatformCategory_LinkViewEvent {
    return PlatformCategory_LinkViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_LinkViewEvent>, I>>(
    object: I,
  ): PlatformCategory_LinkViewEvent {
    const message = createBasePlatformCategory_LinkViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_RadioClickEvent(): PlatformCategory_RadioClickEvent {
  return { targetName: "", optionName: "" };
}

export const PlatformCategory_RadioClickEvent = {
  fromJSON(object: any): PlatformCategory_RadioClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : "",
      optionName: isSet(object.optionName) ? String(object.optionName) : "",
    };
  },

  toJSON(message: PlatformCategory_RadioClickEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    if (message.optionName !== "") {
      obj.optionName = message.optionName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_RadioClickEvent>, I>>(
    base?: I,
  ): PlatformCategory_RadioClickEvent {
    return PlatformCategory_RadioClickEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_RadioClickEvent>, I>>(
    object: I,
  ): PlatformCategory_RadioClickEvent {
    const message = createBasePlatformCategory_RadioClickEvent();
    message.targetName = object.targetName ?? "";
    message.optionName = object.optionName ?? "";
    return message;
  },
};

function createBasePlatformCategory_RadioViewEvent(): PlatformCategory_RadioViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_RadioViewEvent = {
  fromJSON(object: any): PlatformCategory_RadioViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_RadioViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_RadioViewEvent>, I>>(base?: I): PlatformCategory_RadioViewEvent {
    return PlatformCategory_RadioViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_RadioViewEvent>, I>>(
    object: I,
  ): PlatformCategory_RadioViewEvent {
    const message = createBasePlatformCategory_RadioViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_TextViewEvent(): PlatformCategory_TextViewEvent {
  return { targetName: "" };
}

export const PlatformCategory_TextViewEvent = {
  fromJSON(object: any): PlatformCategory_TextViewEvent {
    return { targetName: isSet(object.targetName) ? String(object.targetName) : "" };
  },

  toJSON(message: PlatformCategory_TextViewEvent): unknown {
    const obj: any = {};
    if (message.targetName !== "") {
      obj.targetName = message.targetName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_TextViewEvent>, I>>(base?: I): PlatformCategory_TextViewEvent {
    return PlatformCategory_TextViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_TextViewEvent>, I>>(
    object: I,
  ): PlatformCategory_TextViewEvent {
    const message = createBasePlatformCategory_TextViewEvent();
    message.targetName = object.targetName ?? "";
    return message;
  },
};

function createBasePlatformCategory_PageViewEvent(): PlatformCategory_PageViewEvent {
  return {};
}

export const PlatformCategory_PageViewEvent = {
  fromJSON(_: any): PlatformCategory_PageViewEvent {
    return {};
  },

  toJSON(_: PlatformCategory_PageViewEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_PageViewEvent>, I>>(base?: I): PlatformCategory_PageViewEvent {
    return PlatformCategory_PageViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_PageViewEvent>, I>>(_: I): PlatformCategory_PageViewEvent {
    const message = createBasePlatformCategory_PageViewEvent();
    return message;
  },
};

function createBasePlatformCategory_PageLoadedEvent(): PlatformCategory_PageLoadedEvent {
  return { loadTimeMs: undefined, routerPath: undefined };
}

export const PlatformCategory_PageLoadedEvent = {
  fromJSON(object: any): PlatformCategory_PageLoadedEvent {
    return {
      loadTimeMs: isSet(object.loadTimeMs) ? Number(object.loadTimeMs) : undefined,
      routerPath: isSet(object.routerPath) ? String(object.routerPath) : undefined,
    };
  },

  toJSON(message: PlatformCategory_PageLoadedEvent): unknown {
    const obj: any = {};
    if (message.loadTimeMs !== undefined) {
      obj.loadTimeMs = message.loadTimeMs;
    }
    if (message.routerPath !== undefined) {
      obj.routerPath = message.routerPath;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_PageLoadedEvent>, I>>(
    base?: I,
  ): PlatformCategory_PageLoadedEvent {
    return PlatformCategory_PageLoadedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_PageLoadedEvent>, I>>(
    object: I,
  ): PlatformCategory_PageLoadedEvent {
    const message = createBasePlatformCategory_PageLoadedEvent();
    message.loadTimeMs = object.loadTimeMs ?? undefined;
    message.routerPath = object.routerPath ?? undefined;
    return message;
  },
};

function createBasePlatformCategory_ScreenViewEvent(): PlatformCategory_ScreenViewEvent {
  return {};
}

export const PlatformCategory_ScreenViewEvent = {
  fromJSON(_: any): PlatformCategory_ScreenViewEvent {
    return {};
  },

  toJSON(_: PlatformCategory_ScreenViewEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_ScreenViewEvent>, I>>(
    base?: I,
  ): PlatformCategory_ScreenViewEvent {
    return PlatformCategory_ScreenViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_ScreenViewEvent>, I>>(
    _: I,
  ): PlatformCategory_ScreenViewEvent {
    const message = createBasePlatformCategory_ScreenViewEvent();
    return message;
  },
};

function createBasePlatformCategory_CustomerOneTimeExperienceEvent(): PlatformCategory_CustomerOneTimeExperienceEvent {
  return { experienceName: "" };
}

export const PlatformCategory_CustomerOneTimeExperienceEvent = {
  fromJSON(object: any): PlatformCategory_CustomerOneTimeExperienceEvent {
    return { experienceName: isSet(object.experienceName) ? String(object.experienceName) : "" };
  },

  toJSON(message: PlatformCategory_CustomerOneTimeExperienceEvent): unknown {
    const obj: any = {};
    if (message.experienceName !== "") {
      obj.experienceName = message.experienceName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_CustomerOneTimeExperienceEvent>, I>>(
    base?: I,
  ): PlatformCategory_CustomerOneTimeExperienceEvent {
    return PlatformCategory_CustomerOneTimeExperienceEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_CustomerOneTimeExperienceEvent>, I>>(
    object: I,
  ): PlatformCategory_CustomerOneTimeExperienceEvent {
    const message = createBasePlatformCategory_CustomerOneTimeExperienceEvent();
    message.experienceName = object.experienceName ?? "";
    return message;
  },
};

function createBasePlatformCategory_LeadOneTimeExperienceEvent(): PlatformCategory_LeadOneTimeExperienceEvent {
  return { experienceName: "", leadId: "", sellerLeadUuid: "" };
}

export const PlatformCategory_LeadOneTimeExperienceEvent = {
  fromJSON(object: any): PlatformCategory_LeadOneTimeExperienceEvent {
    return {
      experienceName: isSet(object.experienceName) ? String(object.experienceName) : "",
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: PlatformCategory_LeadOneTimeExperienceEvent): unknown {
    const obj: any = {};
    if (message.experienceName !== "") {
      obj.experienceName = message.experienceName;
    }
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_LeadOneTimeExperienceEvent>, I>>(
    base?: I,
  ): PlatformCategory_LeadOneTimeExperienceEvent {
    return PlatformCategory_LeadOneTimeExperienceEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_LeadOneTimeExperienceEvent>, I>>(
    object: I,
  ): PlatformCategory_LeadOneTimeExperienceEvent {
    const message = createBasePlatformCategory_LeadOneTimeExperienceEvent();
    message.experienceName = object.experienceName ?? "";
    message.leadId = object.leadId ?? "";
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBasePlatformCategory_CustomerUnsubscribeEvent(): PlatformCategory_CustomerUnsubscribeEvent {
  return { feedName: "" };
}

export const PlatformCategory_CustomerUnsubscribeEvent = {
  fromJSON(object: any): PlatformCategory_CustomerUnsubscribeEvent {
    return { feedName: isSet(object.feedName) ? String(object.feedName) : "" };
  },

  toJSON(message: PlatformCategory_CustomerUnsubscribeEvent): unknown {
    const obj: any = {};
    if (message.feedName !== "") {
      obj.feedName = message.feedName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_CustomerUnsubscribeEvent>, I>>(
    base?: I,
  ): PlatformCategory_CustomerUnsubscribeEvent {
    return PlatformCategory_CustomerUnsubscribeEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_CustomerUnsubscribeEvent>, I>>(
    object: I,
  ): PlatformCategory_CustomerUnsubscribeEvent {
    const message = createBasePlatformCategory_CustomerUnsubscribeEvent();
    message.feedName = object.feedName ?? "";
    return message;
  },
};

function createBasePlatformCategory_SessionStartEvent(): PlatformCategory_SessionStartEvent {
  return {};
}

export const PlatformCategory_SessionStartEvent = {
  fromJSON(_: any): PlatformCategory_SessionStartEvent {
    return {};
  },

  toJSON(_: PlatformCategory_SessionStartEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_SessionStartEvent>, I>>(
    base?: I,
  ): PlatformCategory_SessionStartEvent {
    return PlatformCategory_SessionStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_SessionStartEvent>, I>>(
    _: I,
  ): PlatformCategory_SessionStartEvent {
    const message = createBasePlatformCategory_SessionStartEvent();
    return message;
  },
};

function createBasePlatformCategory_SessionEndEvent(): PlatformCategory_SessionEndEvent {
  return {};
}

export const PlatformCategory_SessionEndEvent = {
  fromJSON(_: any): PlatformCategory_SessionEndEvent {
    return {};
  },

  toJSON(_: PlatformCategory_SessionEndEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_SessionEndEvent>, I>>(
    base?: I,
  ): PlatformCategory_SessionEndEvent {
    return PlatformCategory_SessionEndEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_SessionEndEvent>, I>>(
    _: I,
  ): PlatformCategory_SessionEndEvent {
    const message = createBasePlatformCategory_SessionEndEvent();
    return message;
  },
};

function createBasePlatformCategory_InitialPageViewEvent(): PlatformCategory_InitialPageViewEvent {
  return {};
}

export const PlatformCategory_InitialPageViewEvent = {
  fromJSON(_: any): PlatformCategory_InitialPageViewEvent {
    return {};
  },

  toJSON(_: PlatformCategory_InitialPageViewEvent): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_InitialPageViewEvent>, I>>(
    base?: I,
  ): PlatformCategory_InitialPageViewEvent {
    return PlatformCategory_InitialPageViewEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_InitialPageViewEvent>, I>>(
    _: I,
  ): PlatformCategory_InitialPageViewEvent {
    const message = createBasePlatformCategory_InitialPageViewEvent();
    return message;
  },
};

function createBasePlatformCategory_AppLaunchedEvent(): PlatformCategory_AppLaunchedEvent {
  return { fromBackground: false, url: undefined, referringApplication: undefined, version: "", build: "" };
}

export const PlatformCategory_AppLaunchedEvent = {
  fromJSON(object: any): PlatformCategory_AppLaunchedEvent {
    return {
      fromBackground: isSet(object.fromBackground) ? Boolean(object.fromBackground) : false,
      url: isSet(object.url) ? String(object.url) : undefined,
      referringApplication: isSet(object.referringApplication) ? String(object.referringApplication) : undefined,
      version: isSet(object.version) ? String(object.version) : "",
      build: isSet(object.build) ? String(object.build) : "",
    };
  },

  toJSON(message: PlatformCategory_AppLaunchedEvent): unknown {
    const obj: any = {};
    if (message.fromBackground === true) {
      obj.fromBackground = message.fromBackground;
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.referringApplication !== undefined) {
      obj.referringApplication = message.referringApplication;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.build !== "") {
      obj.build = message.build;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AppLaunchedEvent>, I>>(
    base?: I,
  ): PlatformCategory_AppLaunchedEvent {
    return PlatformCategory_AppLaunchedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AppLaunchedEvent>, I>>(
    object: I,
  ): PlatformCategory_AppLaunchedEvent {
    const message = createBasePlatformCategory_AppLaunchedEvent();
    message.fromBackground = object.fromBackground ?? false;
    message.url = object.url ?? undefined;
    message.referringApplication = object.referringApplication ?? undefined;
    message.version = object.version ?? "";
    message.build = object.build ?? "";
    return message;
  },
};

function createBasePlatformCategory_AppForegroundedEvent(): PlatformCategory_AppForegroundedEvent {
  return { fromBackground: false, version: "", build: "" };
}

export const PlatformCategory_AppForegroundedEvent = {
  fromJSON(object: any): PlatformCategory_AppForegroundedEvent {
    return {
      fromBackground: isSet(object.fromBackground) ? Boolean(object.fromBackground) : false,
      version: isSet(object.version) ? String(object.version) : "",
      build: isSet(object.build) ? String(object.build) : "",
    };
  },

  toJSON(message: PlatformCategory_AppForegroundedEvent): unknown {
    const obj: any = {};
    if (message.fromBackground === true) {
      obj.fromBackground = message.fromBackground;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.build !== "") {
      obj.build = message.build;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AppForegroundedEvent>, I>>(
    base?: I,
  ): PlatformCategory_AppForegroundedEvent {
    return PlatformCategory_AppForegroundedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AppForegroundedEvent>, I>>(
    object: I,
  ): PlatformCategory_AppForegroundedEvent {
    const message = createBasePlatformCategory_AppForegroundedEvent();
    message.fromBackground = object.fromBackground ?? false;
    message.version = object.version ?? "";
    message.build = object.build ?? "";
    return message;
  },
};

function createBasePlatformCategory_AppBackgroundedEvent(): PlatformCategory_AppBackgroundedEvent {
  return { version: "", build: "" };
}

export const PlatformCategory_AppBackgroundedEvent = {
  fromJSON(object: any): PlatformCategory_AppBackgroundedEvent {
    return {
      version: isSet(object.version) ? String(object.version) : "",
      build: isSet(object.build) ? String(object.build) : "",
    };
  },

  toJSON(message: PlatformCategory_AppBackgroundedEvent): unknown {
    const obj: any = {};
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.build !== "") {
      obj.build = message.build;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlatformCategory_AppBackgroundedEvent>, I>>(
    base?: I,
  ): PlatformCategory_AppBackgroundedEvent {
    return PlatformCategory_AppBackgroundedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlatformCategory_AppBackgroundedEvent>, I>>(
    object: I,
  ): PlatformCategory_AppBackgroundedEvent {
    const message = createBasePlatformCategory_AppBackgroundedEvent();
    message.version = object.version ?? "";
    message.build = object.build ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
